export default __webpack_public_path__ + "static/media/grocery13.687edf54.jpeg";